import { useContext } from 'react';
import { Store } from './GlobalStore';
export default function useCurrentWorkspace(workspaceUid) {
    var _a;
    const { globalState, setGlobalState } = useContext(Store);
    return (_a = globalState === null || globalState === void 0 ? void 0 : globalState.signedUser) === null || _a === void 0 ? void 0 : _a.workspaces.find((it) => it.uid == workspaceUid);
}
